export default __webpack_public_path__ + "static/d33cab0db74c8c6630052d90688657c3.ttf";